module.exports = __webpack_public_path__ + "static/media/1.jpg.2f8b5185.webp";